<template>
  <page
    :custom-style="{
      backgroundColor: isEmpty ? '#fff' : '#332011',
      minHeight: '100vh'
    }"
  >
    <maple-nav-bar
      v-if="!isMiniProgram"
      class="cms-nav-bar"
      left-arrow
      :safe-top-distance="statusBarHeight"
      :opacity-style="!isEmpty"
      :opacity="opacity"
      :title="pageTitle"
      :left-arrow-color="isEmpty ? '#444' : '#fff'"
      :background="background"
      :title-color="titleColor"
      @click-left="goBack"
    />

    <empty
      v-if="isEmpty && !isLoading"
      :desc="'暂无商品'"
      :type="1"
      :img="'Empty'"
      class="empty-box"
    ></empty>
    <template v-else>
      <div
        v-if="!isEmpty"
        ref="expandHeader"
        class="hot-sale-header"
        :style="{
          backgroundImage: 'url(' + headImg + ')'
        }"
      >
        <p class="header-content" :style="{ top: 44 + statusBarHeight + 'px' }">
          {{ pageTitle }}
        </p>
      </div>
      <div v-if="!isEmpty" class="rank-cotent">
        <div v-for="(item, index) in dataList" :key="index" class="good-item">
          <component
            :is="getComponentType(good)"
            v-for="(good, skuIndex) in item.demandGoods"
            :key="good.skuBase.skuId"
            :sku-index="skuIndex"
            :sku="good"
            :router-name="'demandWordRank'"
            :report-modle="'demandwordRank'"
            :map-id="'demandwordRankExpose'"
            :common-tracer-param="{
              datatype: type,
              word_name: wordName
            }"
          ></component>
        </div>
        <page-bottom use-logo></page-bottom>
      </div>
    </template>

    <cart-float-window />
  </page>
</template>
<script>
import { miniProgramEnv } from '@/defines/environment'
import { API } from '@/api'
import ScrollView from '@/common/widget/ScrollView/index.vue'
import SkuSingle from '@/common/widgets/newGood/skuSingle'
import SkuMultiple from '@/common/widgets/newGood/skuMultiple'
import Empty from '@/common/layout/empty/index'
import headBgImg from '@/images/goods_rank/rank_head.png'
import CartFloatWindow from '@/common/widgets/cart_float_window'
import PageBottom from '@/common/widget/pageBottom'
import Url from '@mc/mc-utils/js/url/url'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
export default {
  name: 'DemandWordRank',
  components: {
    ScrollView,
    Empty,
    SkuSingle,
    SkuMultiple,
    CartFloatWindow,
    PageBottom
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.goodsRank()
    })
  },
  data() {
    return {
      type: 1,
      wordName: '',
      dataList: [],
      isLoading: true,
      isMiniProgram: miniProgramEnv.isMiniProgram,
      headImg: headBgImg,
      pageTitle: '',
      demandWords: [],
      demandWordIndex: 0,
      opacity: 1,
      background: 'transparent',
      titleColor: 'transparent'
    }
  },
  computed: {
    isEmpty() {
      return this.dataList.length === 0
    }
  },
  // 监控路由状态的改变获取参数重载页面
  watch: {
    $route(to, from) {
      location.reload()
    }
  },
  methods: {
    getComponentType(good) {
      if (good.ssuList.length === 1) {
        return 'sku-single'
      } else {
        return 'sku-multiple'
      }
    },
    async goodsRank() {
      this.$Loading()
      const url = new Url(window.location.href)
      const query = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
      const type = query.type || hashQuery.type || ''
      const word = query.word || hashQuery.word || ''
      this.type = type
      this.wordName = word
      tracerVuePlugin.page('#/demand-word-rank', {
        datatype: type
      })
      try {
        this.isLoading = true
        this.opacity = 1
        this.background = 'transparent'
        this.titleColor = 'transparent'
        const data = await API.recommend.goodsRank({ type, demandWords: word })
        this.dataList = data.rows || []
        this.demandWords = this.dataList.map(item => item.demandWords)
        this.demandWordIndex = 0

        this.isLoading = false
        this.pageTitle = data.title || ''
        document.title = this.pageTitle
        this.$nextTick(() => {
          this.handleScroll()
        })
      } catch (e) {
        console.log('e', e)
        this.isLoading = false
      }
      this.$Loading.hide()
    },
    changeTab(index) {
      this.demandWordIndex = index
    },
    goBack() {
      this.$back()
    },
    handleScroll() {
      if (this.isEmpty || !this.$refs.expandHeader) return
      window.addEventListener('scroll', e => {
        const boundingTop = this.$refs.expandHeader?.getBoundingClientRect()
          ?.top

        if (boundingTop < -60) {
          this.opacity = 1
          this.background = '#332011'
          this.titleColor = '#fff'
        } else {
          this.background = 'transparent'
          this.titleColor = 'transparent'
        }
      })
    },
    goDemandWord(word) {
      this.$router.push({
        name: 'demandWordRank',
        query: {
          type: this.type,
          word
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.hot-sale-header {
  position: relative;

  height: 3.44rem /* 172/50 */;

  color: #fff;
  background-size: 100% 100%;

  .header-content {
    position: absolute;
    top: 1.2rem;

    left: 0.46rem /* 23/50 */;

    @include flex-row-center;

    @include text(0.56rem /* 28/50 */, #ffe1bd, true);
  }
}
.rank-cotent {
  box-sizing: border-box;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  position: relative;
  top: -12px;
  background-color: #fff;
  .good-item {
    background-color: #fff;
    padding-bottom: 6px;
  }
}
.expand-tab {
  position: sticky;
  left: 0;
  z-index: 9;

  .feed-tab-scroll {
    writing-mode: initial !important;
    @include flex(row, flex-start, flex-start, nowrap);
    padding-left: 8px;
    padding-top: 8px;
    padding-bottom: 12px;
    background-color: #332011;
    background-image: url('../../images/goods_rank/rank_tab.png');
    background-size: 100% 45px;
    background-repeat: no-repeat;
    box-sizing: border-box;
  }

  .demand-word {
    width: max-content;
    height: 25px;
    box-sizing: border-box;
    flex: none;
    flex-shrink: 0;
    border-radius: 14px; /* 圆角大小 */
    margin-right: 12px;
    transition: all 0.3s;
    padding: 4px 12px;
    background: #ffffff1a;
    border-radius: 14px;
    @include text(12px, #ffe6c7);
    @include flex-row-center;
    &.active {
      background-image: linear-gradient(90deg, #ffefdb 0%, #ffe1bd 100%);
      color: #673900;
    }
  }
}

.cms-nav-bar {
  position: fixed;
  top: 0;
  z-index: $z-navigation-bar;

  width: 100vw;
}
</style>
